import { render, staticRenderFns } from "./MentionCardWrapper.vue?vue&type=template&id=49e8b782"
import script from "./MentionCardWrapper.vue?vue&type=script&lang=js"
export * from "./MentionCardWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports